import _extends from 'babel-runtime/helpers/extends';

import lazyImg from '@/components/LazyImg';
import TableList from '@/components/TableList/index.vue';
import _ from 'lodash';
import { parseTime } from '@/filters/index';
// import { advGradeList } from '@/common/demand'
import AutoTips from '@com/components/auto-tips/index.vue';
import { getGradingLabel, auditResultOptions, remarkOptions } from './review';
import { getWhitelistReasonLabel } from '@/common/creative-whitelist';

export default {
  components: {
    lazyImg: lazyImg,
    TableList: TableList,
    AutoTips: AutoTips
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    tabName: {
      type: String,
      default: ''
    },
    batchIds: {
      type: String,
      default: ''
    },
    showAuditDialog: {
      type: Function,
      default: function _default() {}
    },
    processDraft: {
      type: Function,
      default: function _default() {}
    },
    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    },
    showMaterialDialog: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      tableConfig: {
        'row-class-name': function rowClassName(_ref) {
          var row = _ref.row;

          // 初审、草稿、巡审中的素材，如果命中敏感广告主/产品标签，则高亮
          if ([1, 6, 7].includes(row.status) && (row.adv_warning || row.tag_warning)) {
            return 'warning-row-class';
          }
          return '';
        }
      }
    };
  },


  computed: {
    innerColumnConfig: function innerColumnConfig() {
      var _this = this;

      var mainConfig = [{
        // Pending与Review阶段，表格处理选项
        label: '选择',
        prop: 'selection',
        type: 'selection',
        fixed: 'left',
        selectable: function selectable(row, index) {
          // 非playable和endcard类型支持批量审核
          return ['playable 2D', 'playable 3D', '动态endcard', 'interactive video'].every(function (val) {
            return val !== row.creative_type;
          }) && row.is_dco !== 1;
        },
        visible: ['pending（初审）', 'draft（草稿）', 'Cross-Review（复审）', 'Audit Result（审核结果）', 'Re-Review（巡审）'].indexOf(this.tabName) !== -1
      }, {
        prop: 'id',
        slot: 'id-cell',
        visible: true
      }, {
        prop: 'preview-cell',
        slot: 'preview-cell',
        visible: true
      }, {
        prop: 'action-cell',
        slot: 'action-cell',
        visible: true
      }, {
        label: 'Creative ID',
        prop: 'creative_id',
        fixed: 'left',
        visible: true
      }, {
        label: 'Creative name',
        prop: 'creative_name',
        fixed: 'left',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            if (row.demand_id !== 0) {
              return row.creative_name + '<p>\u5173\u8054\u9700\u6C42\uFF1A<a href="#/butler/demand-detail/' + row.demand_id + '">' + row.demand_id + '</a></p>';
            }
            return row.creative_name;
          }
        },
        visible: true
      }, {
        label: '优先级',
        prop: 'priority',
        fixed: 'left',
        visible: ['Re-Review（巡审）'].indexOf(this.tabName) !== -1
      }, {
        label: 'Creative type',
        prop: 'creative_type',
        visible: true
      }, {
        label: 'Offer name',
        prop: 'offer_name',
        visible: true
      }, {
        label: 'UUID',
        prop: 'offer_uuid',
        visible: true
      }, {
        label: 'Package Name',
        prop: 'package_name',
        visible: true
      }, {
        label: 'App Name',
        prop: 'app_name',
        visible: true,
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            if (row.app_name && row.ext_market_url) {
              return '<a href="' + row.ext_market_url + '" target="_blank">' + row.app_name + '</a>';
            }
            return row.app_name ? row.app_name : '-';
          }
        }
      }, {
        prop: 'adv_name',
        slot: 'adv_name',
        visible: true
      }, {
        prop: 'whitelist-cell',
        slot: 'whitelist-cell',
        visible: true
      }, {
        label: 'APP分级',
        prop: 'content_rating',
        visible: true,
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            if (row.app_tag) {
              return row.app_tag.content_rating ? row.app_tag.content_rating : '-';
            }
            return '-';
          }
        }
      }, {
        label: 'APP Tag',
        slot: 'app_tag',
        visible: true
      }, {
        label: 'Project Tag',
        slot: 'project_tag',
        visible: true
      }, {
        prop: 'offer_geo',
        slot: 'offer_geo',
        visible: true
      }, {
        prop: 'creative_geo',
        slot: 'creative_geo',
        visible: true
      },
      // {
      //   label: 'Platform',
      //   prop: 'platform',
      //   visible: true,
      // },
      // {
      //   label: 'Create From',
      //   prop: 'creative_from',
      //   params: {
      //     innerText({ row }) {
      //       if (row.creative_from === 1) {
      //         return 'adv'
      //       } else if (row.creative_from === 2) {
      //         return 'playturbo'
      //       }
      //       return 'self-made'
      //     },
      //   },
      //   visible: true,
      // },
      // {
      //   label: 'Grade',
      //   prop: 'adv_grade',
      //   visible: true,
      //   params: {
      //     innerText({ row }) {
      //       const temp = advGradeList.find(
      //         (item) => Number(item.value) === Number(row.adv_grade),
      //       )
      //       return temp ? temp.label : '-'
      //     },
      //   },
      // },
      {
        label: 'Upload Time',
        prop: 'upload_time',
        type: 'time',
        visible: true
      }, {
        prop: 'pm-cell',
        slot: 'pm-cell',
        visible: true
      }, {
        // 复审页上一个审核人
        prop: 'final_operator',
        slot: 'last-operator-cell',
        visible: this.tabName === 'Re-Review（巡审）'
      }, {
        prop: 'draft_time',
        label: 'Draft Operator',
        width: 120,
        visible: this.tabName !== 'pending（初审）' && this.tabName !== '机器审核',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            if (row.draft_operator) {
              return '\n                <span><strong>Operator:</strong> ' + (row.draft_operator || '-') + '</span><br>\n                <span><strong>Time:</strong>' + (parseTime(row.draft_time, '{y}-{m}-{d} {h}:{i}') || '-') + '</span>\n              ';
            }
            return '-';
          }
        }
      }, {
        prop: 'draft_note',
        label: 'Notes',
        width: 150,
        visible: this.tabName !== 'pending（初审）' && this.tabName !== '机器审核',
        params: {
          innerText: function innerText(_ref6) {
            var row = _ref6.row;

            return row.draft_note || '-';
          }
        }
      }, {
        prop: 'audit_remark',
        label: '审核备注',
        width: 150,
        visible: true,
        params: {
          innerText: function innerText(_ref7) {
            var row = _ref7.row;

            if (row.audit_remark) {
              var remarkValues = row.audit_remark.split(',').map(Number);
              return remarkValues.map(function (value) {
                var option = remarkOptions.find(function (s) {
                  return s.value === value;
                });
                return option ? option.label : null;
              }).filter(function (label) {
                return label !== null;
              }).join();
            }
            return '-';
          }
        }
      }, {
        prop: 'material_grading',
        label: '素材分级',
        width: 150,
        visible: ['pending（初审）', '机器审核'].indexOf(this.tabName) === -1,
        params: {
          innerText: function innerText(_ref8) {
            var row = _ref8.row;

            return row.material_grading ? getGradingLabel(row.material_grading) : '-';
          }
        }
      }, {
        // 操作员列
        prop: 'first-operator-cell',
        slot: 'first-operator-cell',
        visible: this.tabName !== 'pending（初审）' && this.tabName !== 'draft（草稿）' && this.tabName !== '机器审核' && this.tabName !== 'Re-Review（巡审）'
      }, {
        // 终审操作员列
        prop: 'final-operator-cell',
        slot: 'final-operator-cell',
        visible: ['pending（初审）', 'draft（草稿）', 'Cross-Review（复审）', 'Testing（测试中）', 'Re-Review（巡审）', '机器审核'].every(function (item) {
          return item !== _this.tabName;
        })
      }, {
        prop: 'is_rereview',
        label: '是否巡审',
        visible: this.tabName === 'Audit Result（审核结果）',
        params: {
          innerText: function innerText(_ref9) {
            var row = _ref9.row;

            return row.is_rereview === 1 ? '是' : '否';
          }
        }
      }, {
        prop: 'is_review',
        label: '是否经过复审',
        visible: this.tabName === 'Audit Result（审核结果）',
        params: {
          innerText: function innerText(_ref10) {
            var row = _ref10.row;

            return row.is_review === 1 ? '是' : '否';
          }
        }
      }, {
        label: 'Audit result',
        width: 120,
        visible: this.tabName === 'Audit Result（审核结果）',
        prop: 'status',
        params: {
          innerText: function innerText(_ref11) {
            var row = _ref11.row;

            var temp = auditResultOptions.find(function (s) {
              return s.value === row.status;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        // 拒绝原因
        prop: 'reject-cell',
        slot: 'reject-cell',
        visible: this.tabName === 'Audit Result（审核结果）'
      }];
      // return mainConfig
      return mainConfig.filter(function (item) {
        return item.visible;
      }).map(function (item) {
        return _extends({}, _.omit(item, 'visible'));
      });
    }
  },

  methods: {
    getWhitelistReasonLabel: getWhitelistReasonLabel,
    handleDraft: function handleDraft(index, row) {
      this.processDraft(row);
    },
    handleDetail: function handleDetail(index, row) {
      this.showMaterialDialog(row);
    },
    handleAudit: function handleAudit(index, row) {
      this.showAuditDialog(row);
    },
    isMp4: function isMp4(link) {
      return (/\.mp4$/.test(link)
      );
    },
    isImage: function isImage(link) {
      return (/(\.jp(e)?g|\.png|\.gif)$/.test(link)
      );
    },
    getReason: function getReason(result) {
      try {
        var resultJson = JSON.parse(result);
        return resultJson.reason_text;
      } catch (error) {
        return '接口异常或未知原因';
      }
    }
  },
  watch: {
    batchIds: function batchIds(val) {
      if (val === '') this.$refs.meterialList.clearSelection();
    }
  }
};